import CT from '@marketplace-ai/tags';
import { useSelector } from '@xstate/react';
import { BasicGrid } from '~/components/agGrid/Grid';
import { PROVIDER_PAGE_KEYS } from '~/routing/routes';
import { UserContext } from '../../../app';
import { EmptyState, FormDialog, TableCard } from '../../../components';
import { createMedLicenseCols } from './constants';
import { MedicalLicenseForm } from './MedicalLicenseForm';
import { CreateMedLicenseFormValues, MedLicenseFormValues } from './types';
const TAGS = CT.medicalLicenses.table;

const MedLicenseNoRowsOverlay = () => (
  <EmptyState
    pageKey={PROVIDER_PAGE_KEYS.medicalLicense}
    title="No medical licenses yet"
    cyTag={TAGS.emptyState}
  />
);

export const MedicalLicenseDetails = () => {
  const { vaultRef } = useSelector(UserContext.useActorRef(), (state) => {
    return state.context;
  });
  if (!vaultRef) {
    return null;
  }
  const { medLicenseRef } = useSelector(vaultRef, (state) => {
    return state.context;
  });
  const { medicalLicenses, loading, medLicensesForm, modal, _medicalLicenseTypeOptions } =
    useSelector(medLicenseRef, (state) => state.context);
  const { create, edit } = useSelector(medLicenseRef, (state) => state.context.modal);

  const handleEdit = (id: number) => {
    medLicenseRef.send({ type: 'ON_EDIT', payload: { id } });
  };

  const handleAdd = () => {
    medLicenseRef.send({ type: 'ON_ADD' });
  };

  const handleDelete = (id: number) => {
    medLicenseRef.send({ type: 'ON_SEND_DELETE_CONFIRMATION', payload: { id } });
  };

  const handleClose = () => {
    medLicenseRef.send({ type: 'ON_CLOSE_MODAL' });
  };

  const addLicense = (license: CreateMedLicenseFormValues) => {
    medLicenseRef.send({ type: 'ON_SUBMIT', values: license });
  };

  const editLicense = (license: MedLicenseFormValues) => {
    medLicenseRef.send({ type: 'ON_UPDATE', values: license });
  };

  return (
    <>
      <TableCard
        mobilePageHeader
        title="Medical Licenses"
        addLabel="Add Medical License"
        onAddClick={handleAdd}
        addBtnTag={TAGS.addBtn}
        layoutTag={CT.medicalLicenses.layout}
      >
        <BasicGrid
          newRecordsTable="medical_licenses"
          loading={loading}
          data={medicalLicenses}
          cyTag={CT.medicalLicenses.grid}
          colDefs={createMedLicenseCols({ handleDelete, handleEdit })}
          pagination={true}
          noRowsOverlayComponent={MedLicenseNoRowsOverlay}
        />
      </TableCard>
      <FormDialog
        title={create ? 'Add New Medical License' : 'Edit Medical License'}
        editing={edit}
        creating={create}
        onClose={handleClose}
      >
        <MedicalLicenseForm
          addLicense={addLicense}
          editLicense={editLicense}
          handleClose={handleClose}
          medLicensesForm={medLicensesForm}
          create={modal.create}
          _medicalLicenseTypeOptions={_medicalLicenseTypeOptions}
        />
      </FormDialog>
    </>
  );
};
